import {
  clearError,
  defineNuxtRouteMiddleware
} from '#app'
import { delocalize, routeLocale } from '#imports'
import { useLayoutStore } from '~/store/layout'
import { useRouteStore } from '~/store/route'
import { useSearchStore } from '~/store/search'

// Route names that should track back navigation (detail/slug pages)
// These match the route names defined in configuration/i18n/routes.js

// const BACK_NAVIGATION_ROUTES = [
//   'news-category-slug',
//   'magazine-category-slug',
//   'maintenance-category-slug',
//   'awards-slug',
//   'initiatives-slug',
//   'kitchens-slug',
//   'living-slug',
//   'complements-slug',
//   'life-stories-slug',
//   'rivenditore-slug',
//   'landings-slug',
//   'pages-slug'
// ]

/**
 * Check if the route should track back navigation
 * Uses delocalized route name to work across all locales
 */

// const shouldTrackBackNavigation = routeName => {
//   if (!routeName) return false
//   const delocalizedName = delocalize(routeName)
//   return BACK_NAVIGATION_ROUTES.includes(delocalizedName)
// }

/**
 * Store back navigation in sessionStorage
 */
// const storeBackNavigation = (fromPath, toPath) => {
//   if (import.meta.client && fromPath && fromPath !== toPath) {
//     const storageKey = `backNavigation:${toPath}`
//     sessionStorage.setItem(storageKey, fromPath)
//   }
// }

export default defineNuxtRouteMiddleware((to, from) => {
  clearError()

  const layout = useLayoutStore()
  const search = useSearchStore()

  const route = useRouteStore()

  if (to.path !== from.path) {
    const noTransitionRoutes = [ 'store-locator-abroad-continent-country', 'store-locator-italy-region-province' ]
    const isChangingLang = routeLocale(to.name) !== routeLocale(from.name)

    route.shouldTransition = !(noTransitionRoutes.includes(delocalize(from.name)) && noTransitionRoutes.includes(delocalize(to.name)) && !isChangingLang)

    route.to = {
      path: to.path,
      fullPath: to.fullPath
    }

    route.from = {
      path: from.path,
      fullPath: from.fullPath
    }

    layout.navIsOpen = false
    layout.subnavIsOpen = false
    layout.transitioning = route.shouldTransition
    search.isPanelOpen = false
    search.query = null
    search.results = []

    // // Store back navigation for pages that need it
    // // Use fullPath to preserve query parameters (e.g., ?filter=123)
    // if (shouldTrackBackNavigation(to.name)) {
    //   storeBackNavigation(from.fullPath, to.path)
    // }
  }
})
